import { message } from "ant-design-vue";
import axios from "@/utils/axios";

function getMessage(options) {
  return typeof options === "string" ? options : options && options.message;
}

const client = {
  request: {
    get(url = "", data = {}, config = {}) {
      return axios.get(url, {
        ...config,
        params: data,
      });
    },
    post(url = "", data = {}, config = {}) {
      return axios.post(url, data, config);
    },
    temGet(url = "", data = {}, config = {}) {
      return axios.temGet(url, data, config);
    },
    temPost(url = "", data = {}, config = {}) {
      return axios.temPost(url, data, config);
    },
  },
  info(options = {}) {
    message.info(getMessage(options));
  },
  success(options = {}) {
    message.success(getMessage(options));
  },
  warning(options = {}) {
    message.warning(getMessage(options));
  },
  error(options = {}) {
    message.error(getMessage(options));
  },
};

export default client;
